// Wspólna warstwa dostępu do DRF dla kontrolerów Stimulus.
// Session auth (cookie) + CSRF z <meta name="csrf-token"> (fallback: cookie csrftoken).

export function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta?.content) return meta.content
  return (document.cookie.match(/csrftoken=([^;]+)/) || [])[1] || ""
}

// GET JSON — rzuca Error przy statusie != 2xx (kontroler pokazuje stan błędu).
export async function getJSON(url) {
  const res = await fetch(url, { headers: { Accept: "application/json" } })
  if (!res.ok) throw new Error(`GET ${url} -> ${res.status}`)
  return res.json()
}

// Mutacja JSON — NIE rzuca: zwraca { ok, status, data }, kontroler decyduje po statusie.
// Brak fallbacku "udawanego sukcesu": nieudany zapis nie może wyglądać jak udany.
export async function sendJSON(method, url, body) {
  let res
  try {
    res = await fetch(url, {
      method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken(),
      },
      body: body === undefined ? undefined : JSON.stringify(body),
    })
  } catch {
    return { ok: false, status: 0, data: null }
  }
  let data = null
  try { data = await res.json() } catch { /* 204 lub nie-JSON */ }
  return { ok: res.ok, status: res.status, data }
}

// Wyciąga komunikat z envelope błędów ({"error":{"detail":…}} albo {"detail":…}).
export function errorDetail(data, fallback) {
  const detail = data?.error?.detail ?? data?.detail
  return typeof detail === "string" && detail ? detail : fallback
}

// "320.00" | 320 -> "320 zł"; "73.60" -> "73,60 zł"
export function formatPln(value) {
  const num = Number(value)
  if (!Number.isFinite(num)) return "—"
  const rounded = Math.round(num * 100) / 100
  const text = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2).replace(".", ",")
  return `${text} zł`
}

/**
 * Formatuje etykietę podkategorii: „Kategoria › Podkategoria".
 * Jedna implementacja współdzielona przez backorder-controller (lista) i subcat-search-controller (autocomplete).
 * @param {{category_name?: string|null, name: string}} item
 * @returns {string}
 */
export function formatSubcatLabel(item) {
  return item.category_name ? `${item.category_name} › ${item.name}` : item.name
}

// ISO -> "01.07.2026, 14:32" (pl-PL)
export function formatDate(iso) {
  if (!iso) return "—"
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return "—"
  return date.toLocaleString("pl-PL", { dateStyle: "short", timeStyle: "short" })
}

// Wyniki z listowego endpointu DRF (paginowane {results} albo goła lista).
export function listResults(data) {
  return Array.isArray(data) ? data : (data?.results ?? [])
}

// Zbierz WSZYSTKIE strony paginowanego endpointu (podążaj za `next`), z twardym capem
// stron jako bezpiecznikiem anty-pętla. Używaj dla słowników i agregacji (metryki,
// join zamówienie↔dostawa) — pojedyncza strona (PAGE_SIZE=25) by je przekłamała.
export async function getAllJSON(url, maxPages = 10) {
  const out = []
  let next = url
  for (let i = 0; i < maxPages && next; i += 1) {
    const data = await getJSON(next)
    if (Array.isArray(data)) return data
    out.push(...(data.results ?? []))
    next = data.next
  }
  return out
}
